var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  width: "100%",
                  "min-width": "160px",
                  height: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _vm.$store.getters.enableFrontEndPlugin
                ? _c(
                    "div",
                    [
                      _c("micro-app", {
                        attrs: {
                          name: "child-sale-role-hide-remotebooking",
                          url:
                            _vm.$store.getters.frontEndPluginUrl +
                            "/saleRoleHideItem",
                          "router-mode": "pure",
                          destroy: ""
                        },
                        on: { datachange: _vm.saleRoleHideDataChange }
                      }),
                      _c("micro-app", {
                        attrs: {
                          name: "child-customer-sales-display-remotebooking",
                          url:
                            _vm.$store.getters.frontEndPluginUrl +
                            "/customerSalesDisplayItem",
                          "router-mode": "pure",
                          destroy: ""
                        },
                        on: { datachange: _vm.customerSalesDisplayDataChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.action === "look",
                              expression: "action==='look'"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "1", type: "primary" },
                              on: { click: _vm.goBack }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ReturnQuery"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "2",
                                disabled: _vm.currentRow.preverifyState === 7,
                                type: "success"
                              },
                              on: { click: _vm.toEdit }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "3", type: "primary" },
                              on: { click: _vm.toCopy }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "4",
                                type: "success",
                                disabled: _vm.currentRow.preverifyState === 7
                              },
                              on: { click: _vm.onPrint }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "5", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.toAdd({ lob: "SE" })
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_AddSeaBooking"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "6", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.toAdd({ lob: "AE" })
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_AddAirBooking"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "7", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.toAdd({ lob: "RE" })
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_AddRailwayBooking")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.submitState,
                                  expression: "!submitState"
                                }
                              ],
                              attrs: {
                                disabled: _vm.currentRow.preverifyState === 7,
                                no: "8",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("lockJob", _vm.currentRow)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_HoldSubmission"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.submitState,
                                  expression: "submitState"
                                }
                              ],
                              attrs: {
                                disabled: _vm.currentRow.preverifyState === 7,
                                no: "9",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("submitJob", _vm.currentRow)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isHc &&
                                    _vm.$checkPermission([
                                      "button_RemoteBooking_revoke"
                                    ]),
                                  expression:
                                    "isHc && $checkPermission(['button_RemoteBooking_revoke'])"
                                }
                              ],
                              attrs: {
                                no: "revoke",
                                disabled: _vm.currentRow.preverifyState !== 4,
                                type: "danger"
                              },
                              on: { click: _vm.toRevoke }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Invalid")))]
                          ),
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.preverifyStateIcon,
                                expression: "preverifyStateIcon"
                              }
                            ],
                            staticStyle: {
                              position: "fixed",
                              "z-index": "99",
                              right: "25%",
                              margin: "-10px 0 0 0"
                            },
                            attrs: {
                              src: _vm.preverifyStateIcon,
                              width: "100",
                              height: "99"
                            }
                          }),
                          _c("span", {
                            staticStyle: {
                              "font-size": "12px",
                              padding: "5px 9px",
                              color: "unset"
                            },
                            domProps: {
                              innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                            }
                          })
                        ],
                        1
                      ),
                      _c("CargoIm", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.imCacheKey && _vm.action === "look",
                            expression: "imCacheKey && action==='look'"
                          }
                        ],
                        ref: "cargoIm"
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.action !== "look",
                              expression: "action!=='look'"
                            }
                          ],
                          staticClass: "new",
                          staticStyle: {
                            "border-left": "none",
                            "padding-left": "0"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "10", type: "success" },
                              on: { click: _vm.save }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "11", type: "success" },
                              on: { click: _vm.cancelEdit }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "12", type: "primary" },
                              on: { click: _vm.saveDefaultVal }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.SaveTheDefaultValues"))
                              )
                            ]
                          ),
                          _c("span", {
                            staticStyle: {
                              "font-size": "12px",
                              padding: "5px 9px",
                              color: "unset"
                            },
                            domProps: {
                              innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _vm.paramsOfTab.lob === "SE"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabSeBooking",
                                label: _vm.$t("CargoMsg.Cargo_Consignation")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-se-booking-UICustom", {
                                    ref: "tabSeBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                                : _c("tab-se-booking", {
                                    ref: "tabSeBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.lob === "AE"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabAeBooking",
                                label: _vm.$t("CargoMsg.Cargo_Consignation")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-ae-booking-UICustom", {
                                    ref: "tabAeBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                                : _c("tab-ae-booking", {
                                    ref: "tabAeBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.lob === "RE" ||
                      _vm.paramsOfTab.lob === "RI"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "railway",
                              attrs: {
                                lazy: true,
                                name: "tabReBooking",
                                label: _vm.$t("CargoMsg.Cargo_Consignation")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-railway-booking-UICustom", {
                                    ref: "tabReBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                                : _c("tab-re-booking", {
                                    ref: "tabReBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.dischargingPortDoor
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDischargingTrucking",
                              attrs: {
                                lazy: true,
                                name: "tabDischargingTrucking",
                                label: _vm.$t(
                                  "SeaExport.DispatchVehiclesAtDestination"
                                )
                              }
                            },
                            [
                              _c("tab-discharging-trucking", {
                                ref: "tabDischargingTrucking",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-sales-for-szfs": _vm.isSalesForSzfs,
                                  "page-source": "remoteBooking"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.destPortCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDestinationCustomsData",
                              attrs: {
                                lazy: true,
                                name: "tabDestinationCustomsData",
                                label: _vm.$t(
                                  "SeaExport.PortOfDestinationCustomsClearance"
                                )
                              }
                            },
                            [
                              _c("tab-destination-customs-data", {
                                ref: "tabDestinationCustomsData",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-sales-for-szfs": _vm.isSalesForSzfs
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.uuid &&
                      (_vm.paramsOfTab.lob === "SE"
                        ? _vm.paramsOfTab.customs
                        : true)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabCustomsInfo",
                                label: _vm.$t("SeaExport.CustomsDeclaration")
                              }
                            },
                            [
                              _vm.paramsOfTab.lob === "SE"
                                ? _c("tab-customs-info", {
                                    ref: "tabCustomsInfo",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                                : _c("tab-customs-info-ae", {
                                    ref: "tabCustomsInfo",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sales-for-szfs": _vm.isSalesForSzfs
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      Boolean(_vm.paramsOfTab.uuid) &&
                      _vm.paramsOfTab.landTransportation
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabTrucking",
                                label: _vm.$t("SeaExport.Trucking")
                              }
                            },
                            [
                              _c("tab-trucking", {
                                ref: "tabTrucking",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-sales-for-szfs": _vm.isSalesForSzfs
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.uuid &&
                      _vm.paramsOfTab.lob === "SE" &&
                      _vm.paramsOfTab.cargoType === "DG"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabSpecialGoods",
                                label: _vm.$t("SpecialGoods.label")
                              }
                            },
                            [
                              _c("tab-special-goods", {
                                ref: "tabSpecialGoods",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["tab_Charge_chargeView"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabCharges",
                                label: _vm.$t("SeaExport.Charge")
                              }
                            },
                            [
                              _c("tab-charges", {
                                ref: "tabCharges",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "RemoteBooking",
                                  "sale-role-hide": _vm.saleRoleHide,
                                  "customer-sales-display":
                                    _vm.customerSalesDisplay
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      Boolean(_vm.paramsOfTab.uuid)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: { context: _vm.context }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("estimate-validation-dialog", {
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.currentRow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "close-callback": _vm.batchCheckingWindow.closeHandler
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.currentRow.lob,
              job: _vm.currentRow,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2,
              "close-callback": _vm.checkingWindow.closeHandler
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: _vm.checkingSaveJobWindow.lob,
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }